import { render } from "./SubTask.vue?vue&type=template&id=06f1b666"
import script from "./SubTask.vue?vue&type=script&lang=js"
export * from "./SubTask.vue?vue&type=script&lang=js"

import "./SubTask.vue?vue&type=style&index=0&id=06f1b666&lang=less"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__